import React from 'react'

import { WithAccounts } from 'data/wrappers/WithAccountsComponent'

export const withAccounts = (Child) => (props) => (
    <WithAccounts>{(accountProps) => <Child {...accountProps} {...props} />}</WithAccounts>
)
